import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import Utility from "../../../util/utilityFunctions";
import MotifToast from '@ey/motif-react-wrapper/Toast';

export interface DataErrorMessageProps {
  message: string;
  callBack: Function;
}

const ErrorSummary = (props) => {
  const [message, setErrorMessage] = useState(props.message);

  useEffect(() => {}, []);

  const hideErrorToast = () => {
    setErrorMessage("");
    props?.callBack();
  };

  return (
    <StyledErrorSection className="error-wrap">     
      {/* <MotifToast
        onClose={() => hideErrorToast()}
        variant="error"
        supportingText={Utility.createRichTextElementName(message)}
      >
        
      </MotifToast> */}
      <MotifToast  
  onClose={() => hideErrorToast()}
  variant="error"
  // supportingText={`${Utility.createRichTextElementName(message)}`}
>
{Utility.createRichTextElementName(message)}
</MotifToast>
    </StyledErrorSection>
  );
};

export default ErrorSummary;

const StyledErrorSection = styled.section`
  position: absolute;
  top: var(--px-8);
  left: var(--px-8);
  width: 95%;
`;